import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ContractRequirementType, GeographicAreaType, handleServerCoverageListItemData } from '@jove-frontend/uikit';
import { cloneDeep, isArray, orderBy, uniqueId } from 'lodash';
export var useValidationExtractCombineResult = function useValidationExtractCombineResult() {
  /**
   * methods
   */
  var getAllRequirements = function getAllRequirements(validationRes) {
    return (validationRes || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), item.validation_requirement);
    }).map(function (item) {
      item.user_overwritten_data = _objectSpread(_objectSpread({}, item.user_overwritten_data), item.displayed_data);
      return item;
    });
  };

  var getAllExtractRequirements = function getAllExtractRequirements(extractRes) {
    var list = [];
    (extractRes || []).forEach(function (item) {
      list.push.apply(list, _toConsumableArray(item.extraction_coverage_list || []));
    });
    return list;
  };

  var combineValidationRequirementsWithExtractData = function combineValidationRequirementsWithExtractData(multipleValidationRequirements, validationRequirements, allExtractCoverList) {
    validationRequirements.forEach(function (item) {
      var haveExtractCoverage = allExtractCoverList.some(function (aItem) {
        var _item$user_overwritte;

        return ((_item$user_overwritte = item.user_overwritten_data) === null || _item$user_overwritte === void 0 ? void 0 : _item$user_overwritte.cover_slug) === aItem.cover_slug;
      });

      if (haveExtractCoverage) {
        allExtractCoverList.forEach(function (aItem) {
          var _item$user_overwritte2;

          if (aItem.cover_slug === ((_item$user_overwritte2 = item.user_overwritten_data) === null || _item$user_overwritte2 === void 0 ? void 0 : _item$user_overwritte2.cover_slug)) {
            multipleValidationRequirements.push(modifyRequirementForEdit(item, aItem, {
              cleanData: false,
              isExtracted: true
            }));
          }
        });
      } else {
        multipleValidationRequirements.push(modifyRequirementForEdit(item, item.user_overwritten_data, {
          cleanData: true,
          isExtracted: false
        }));
      }
    });
  };

  var modifyRequirementForEdit = function modifyRequirementForEdit(item, overwrittenItem, config) {
    var _overwrittenItem$appl, _overwrittenItem$appl2;

    var data = _objectSpread(_objectSpread({}, item), {}, {
      user_overwritten_data: _objectSpread(_objectSpread(_objectSpread({}, item === null || item === void 0 ? void 0 : item.user_overwritten_data), overwrittenItem), {}, {
        start_date: overwrittenItem !== null && overwrittenItem !== void 0 && overwrittenItem.start_date ? new Date(overwrittenItem.start_date) : new Date(),
        end_date: overwrittenItem !== null && overwrittenItem !== void 0 && overwrittenItem.end_date ? new Date(overwrittenItem.end_date) : new Date(),
        is_extracted: !!(config !== null && config !== void 0 && config.isExtracted),
        is_product_missing: !(config !== null && config !== void 0 && config.isExtracted),
        applicable_companies: (overwrittenItem === null || overwrittenItem === void 0 ? void 0 : overwrittenItem.applicable_companies) || [],
        applicable_geographic_area: {
          area_type: (overwrittenItem === null || overwrittenItem === void 0 ? void 0 : (_overwrittenItem$appl = overwrittenItem.applicable_geographic_area) === null || _overwrittenItem$appl === void 0 ? void 0 : _overwrittenItem$appl.area_type) || null,
          countries: (overwrittenItem === null || overwrittenItem === void 0 ? void 0 : (_overwrittenItem$appl2 = overwrittenItem.applicable_geographic_area) === null || _overwrittenItem$appl2 === void 0 ? void 0 : _overwrittenItem$appl2.countries) || []
        }
      }),
      uniqueId: (item === null || item === void 0 ? void 0 : item.id) + uniqueId()
    });

    data.user_overwritten_data = handleServerCoverageListItemData(data.user_overwritten_data);
    return config !== null && config !== void 0 && config.cleanData ? _objectSpread(_objectSpread({}, data), {}, {
      user_overwritten_data: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.user_overwritten_data), cleanCoverItemEditInfo())
    }) : data;
  };

  var cleanCoverItemEditInfo = function cleanCoverItemEditInfo() {
    return {
      policy_number: null,
      policyholder: null,
      insurer_name: null,
      applicable_territories: null,
      amount: null,
      limit_per_occurrence: null,
      el_disease_each_employee: null,
      el_disease_policy_limit: null,
      statutory: null,
      start_date: null,
      end_date: null
    };
  };

  var getMultipleValidationRequirementsWithNoExtractData = function getMultipleValidationRequirementsWithNoExtractData(validationRequirements) {
    return validationRequirements.map(function (item) {
      return modifyRequirementForEdit(item, item.user_overwritten_data, {
        cleanData: true
      });
    });
  };

  var evaluateCheckedRequirementList = function evaluateCheckedRequirementList() {
    var contractRequirements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var validationRequirements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var config = arguments.length > 2 ? arguments[2] : undefined;
    // Remove period of insurance from contract requirements
    var list = cloneDeep((contractRequirements === null || contractRequirements === void 0 ? void 0 : contractRequirements.filter(function (item) {
      return item.type !== ContractRequirementType.PERIOD;
    })) || []);

    if (config !== null && config !== void 0 && config.country_code) {
      list = list.filter(function (item) {
        var _item$data;

        return ((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.country_code) === (config === null || config === void 0 ? void 0 : config.country_code);
      });
    } // Determine what can be displayed based on validation requirement


    list = list.filter(function (item) {
      return validationRequirements.some(function (aItem) {
        return aItem.contract_requirement_id === item.id;
      });
    }); // Add validation to the contract

    list.forEach(function (item) {
      var validationList = [];
      validationRequirements.forEach(function (aItem) {
        if (aItem.contract_requirement_id === item.id) {
          validationList.push(aItem);
        }
      });
      item.validationList = validationList;
    }); // Filter empty array

    list = list.filter(function (item) {
      return item.validationList.length > 0;
    }); // Assignment selected

    list.forEach(function (item, index) {
      evaluateDuplicateCoverRequirementAlertBasicInfo(item, index, {
        countries: config === null || config === void 0 ? void 0 : config.countries
      });
    });
    return list;
  };

  var evaluateCheckedRequirementListByCountry = function evaluateCheckedRequirementListByCountry() {
    var contractRequirements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var validationRequirements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var config = arguments.length > 2 ? arguments[2] : undefined;
    // Remove period of insurance from contract requirements
    var list = cloneDeep((contractRequirements === null || contractRequirements === void 0 ? void 0 : contractRequirements.filter(function (item) {
      return item.type !== ContractRequirementType.PERIOD;
    })) || []); // Determine what can be displayed based on validation requirement

    list = list.filter(function (item) {
      return validationRequirements.some(function (aItem) {
        return aItem.contract_requirement_id === item.id;
      });
    }); // Add validation to the contract

    list.forEach(function (item) {
      var validationList = [];
      validationRequirements.forEach(function (aItem) {
        if (aItem.contract_requirement_id === item.id) {
          validationList.push(aItem);
        }
      });
      item.validationList = validationList;
    }); // Filter empty array

    list = list.filter(function (item) {
      return item.validationList.length > 0;
    }); // Assignment selected

    list.forEach(function (item, index) {
      evaluateDuplicateCoverRequirementAlertBasicInfo(item, index, {
        countries: config === null || config === void 0 ? void 0 : config.countries
      });
    });
    return list;
  };

  var evaluateDuplicateCoverRequirementAlertBasicInfo = function evaluateDuplicateCoverRequirementAlertBasicInfo(item, index, config) {
    item.unfold = index === 0; // Item info

    item.validationList.forEach(function (aItem) {
      aItem.countryInfo = ((config === null || config === void 0 ? void 0 : config.countries) || []).find(function (cItem) {
        var _aItem$user_overwritt;

        return cItem.code === ((_aItem$user_overwritt = aItem.user_overwritten_data) === null || _aItem$user_overwritt === void 0 ? void 0 : _aItem$user_overwritt.coverage_country);
      });
    }); // Recommend

    var defaultIndex = item.validationList.findIndex(function (aItem) {
      var _aItem$user_overwritt2;

      return !!((_aItem$user_overwritt2 = aItem.user_overwritten_data) !== null && _aItem$user_overwritt2 !== void 0 && _aItem$user_overwritt2.is_recommended);
    });

    if (defaultIndex === -1) {
      // Global
      defaultIndex = item.validationList.findIndex(function (aItem) {
        var _aItem$user_overwritt3, _aItem$user_overwritt4;

        return ((_aItem$user_overwritt3 = aItem.user_overwritten_data) === null || _aItem$user_overwritt3 === void 0 ? void 0 : (_aItem$user_overwritt4 = _aItem$user_overwritt3.applicable_geographic_area) === null || _aItem$user_overwritt4 === void 0 ? void 0 : _aItem$user_overwritt4.area_type) === GeographicAreaType.WORLDWIDE;
      });
    }

    item.validationList[defaultIndex === -1 ? 0 : defaultIndex].selected = true; // Flags

    item.allGlobal = item.validationList.every(function (aItem) {
      var _aItem$user_overwritt5, _aItem$user_overwritt6;

      return ((_aItem$user_overwritt5 = aItem.user_overwritten_data) === null || _aItem$user_overwritt5 === void 0 ? void 0 : (_aItem$user_overwritt6 = _aItem$user_overwritt5.applicable_geographic_area) === null || _aItem$user_overwritt6 === void 0 ? void 0 : _aItem$user_overwritt6.area_type) === GeographicAreaType.WORLDWIDE;
    });
    item.haveGlobal = item.validationList.some(function (aItem) {
      var _aItem$user_overwritt7, _aItem$user_overwritt8;

      return ((_aItem$user_overwritt7 = aItem.user_overwritten_data) === null || _aItem$user_overwritt7 === void 0 ? void 0 : (_aItem$user_overwritt8 = _aItem$user_overwritt7.applicable_geographic_area) === null || _aItem$user_overwritt8 === void 0 ? void 0 : _aItem$user_overwritt8.area_type) === GeographicAreaType.WORLDWIDE;
    });
    item.haveSomeRegionCoverage = item.validationList.some(function (aItem) {
      var _aItem$user_overwritt9, _aItem$user_overwritt10;

      return ((_aItem$user_overwritt9 = aItem.user_overwritten_data) === null || _aItem$user_overwritt9 === void 0 ? void 0 : (_aItem$user_overwritt10 = _aItem$user_overwritt9.applicable_geographic_area) === null || _aItem$user_overwritt10 === void 0 ? void 0 : _aItem$user_overwritt10.area_type) !== GeographicAreaType.WORLDWIDE;
    });
    item.haveRecommended = item.validationList.some(function (aItem) {
      var _aItem$user_overwritt11;

      return !!((_aItem$user_overwritt11 = aItem.user_overwritten_data) !== null && _aItem$user_overwritt11 !== void 0 && _aItem$user_overwritt11.is_recommended);
    });
  };

  var convertServerRequirementDataToLocalEditDisplayNeedData = function convertServerRequirementDataToLocalEditDisplayNeedData(list, config) {
    list.forEach(function (item) {
      item.validationList = item.validationList.map(function (aItem) {
        var _ref = aItem.user_overwritten_data || {},
            applicable_geographic_area = _ref.applicable_geographic_area,
            applicable_companies = _ref.applicable_companies; // Convert countries


        if (applicable_geographic_area) {
          var _list = [];
          (applicable_geographic_area.countries || []).forEach(function (cItem) {
            var temp = ((config === null || config === void 0 ? void 0 : config.countries) || []).find(function (country) {
              return country.code === cItem;
            });

            if (temp) {
              _list.push(temp);
            }
          });
          aItem.user_overwritten_data.applicable_geographic_area.countries = _list;
        } // Companies


        if (applicable_companies) {
          var _list2 = [];
          applicable_companies.forEach(function (cItem) {
            var temp = ((config === null || config === void 0 ? void 0 : config.availabledCompanies) || []).find(function (country) {
              return country.value === cItem;
            });

            if (temp) {
              _list2.push(temp);
            }
          });
          aItem.user_overwritten_data.applicable_companies = _list2;
        }

        return aItem;
      });
      item.validationList = orderBy(item.validationList, ['displayCoverSlug', 'asc']);
    });
  };

  var convertServerRequirementDataToLocalEditDisplayNeedDataWithProductListData = function convertServerRequirementDataToLocalEditDisplayNeedDataWithProductListData(list, organizationSubsidiaryList, config) {
    var newList = list.map(function (aItem) {
      var _aItem$extracted_data;

      var _ref2 = aItem.user_overwritten_data || {},
          applicable_geographic_area = _ref2.applicable_geographic_area,
          applicable_companies = _ref2.applicable_companies,
          organization_subsidiary = _ref2.organization_subsidiary; // Convert countries


      if (applicable_geographic_area) {
        var _list3 = [];
        (applicable_geographic_area.countries || []).forEach(function (cItem) {
          var temp = ((config === null || config === void 0 ? void 0 : config.countries) || []).find(function (country) {
            return country.code === cItem;
          });

          if (temp) {
            _list3.push(temp);
          }
        });
        aItem.user_overwritten_data.applicable_geographic_area.countries = _list3;
      } // Companies


      if (applicable_companies) {
        var _list4 = [];
        applicable_companies.forEach(function (cItem) {
          var temp = ((config === null || config === void 0 ? void 0 : config.availabledCompanies) || []).find(function (country) {
            return country.value === cItem;
          });

          if (temp) {
            _list4.push(temp);
          }
        });
        aItem.user_overwritten_data.applicable_companies = _list4;
      }

      aItem.displayApplicableCompaniesText = (((_aItem$extracted_data = aItem.extracted_data) === null || _aItem$extracted_data === void 0 ? void 0 : _aItem$extracted_data.applicable_companies) || []).map(function (cItem) {
        var temp = ((config === null || config === void 0 ? void 0 : config.availabledCompanies) || []).find(function (dItem) {
          return dItem.value === cItem;
        });
        return (temp === null || temp === void 0 ? void 0 : temp.label) || '';
      }).filter(function (cItem) {
        return !!cItem;
      }).join(', '); // organization subsidiary

      if (organization_subsidiary) {
        var textList = [];

        if (isArray(organization_subsidiary)) {
          organization_subsidiary.forEach(function (orgSubId) {
            var temp = organizationSubsidiaryList === null || organizationSubsidiaryList === void 0 ? void 0 : organizationSubsidiaryList.find(function (dItem) {
              return dItem.id === orgSubId;
            });

            if (temp) {
              textList.push(temp.name);
            }
          });
        } else {
          textList.push(organization_subsidiary);
        }

        aItem.user_overwritten_data.organization_subsidiary = textList.join(',');
      }

      return aItem;
    });
    return newList;
  };

  return {
    getAllRequirements: getAllRequirements,
    getAllExtractRequirements: getAllExtractRequirements,
    combineValidationRequirementsWithExtractData: combineValidationRequirementsWithExtractData,
    modifyRequirementForEdit: modifyRequirementForEdit,
    cleanCoverItemEditInfo: cleanCoverItemEditInfo,
    getMultipleValidationRequirementsWithNoExtractData: getMultipleValidationRequirementsWithNoExtractData,
    evaluateCheckedRequirementList: evaluateCheckedRequirementList,
    convertServerRequirementDataToLocalEditDisplayNeedData: convertServerRequirementDataToLocalEditDisplayNeedData,
    evaluateCheckedRequirementListByCountry: evaluateCheckedRequirementListByCountry,
    convertServerRequirementDataToLocalEditDisplayNeedDataWithProductListData: convertServerRequirementDataToLocalEditDisplayNeedDataWithProductListData
  };
};